import React from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import './index.css';
const container = document.getElementById('root');
if (!container) {
  throw new Error('Failed to find root element');
}
const root = createRoot(container);
window.addEventListener('error', (event) => {
  console.error('Global error:', event.error);
  // You could add error reporting service here
});
window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', event.reason);
  // You could add error reporting service here
});
try {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} catch (error) {
  console.error('Error rendering app:', error);
  // Render fallback UI
  root.render(
    <div className="min-h-screen w-full bg-gradient-to-b from-[#050614] to-[#0f1a2f] flex items-center justify-center text-white p-4">
      <div className="max-w-md w-full bg-[#0c1222] border border-[#1a2d4d] rounded-xl p-6 text-center">
        <h1 className="text-2xl font-bold mb-4">Unable to load application</h1>
        <p className="text-gray-300 mb-4">Please try refreshing the page</p>
        <button
          onClick={() => window.location.reload()}
          className="bg-[#4f46e5] hover:bg-[#4338ca] px-4 py-2 rounded transition-colors"
        >
          Refresh
        </button>
      </div>
    </div>
  );
}
